/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  GetApiV1ClassroomdisciplineSharedDisciplines401,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedDisciplines.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ClassroomdisciplineSharedDisciplines } from "../../clients/classPlanningSharedController/getApiV1ClassroomdisciplineSharedDisciplines.ts";

export const getApiV1ClassroomdisciplineSharedDisciplinesQueryKey = (
  params?: GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
) =>
  [
    { url: "/api/v1/classroomdiscipline/shared/disciplines" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ClassroomdisciplineSharedDisciplinesQueryKey = ReturnType<
  typeof getApiV1ClassroomdisciplineSharedDisciplinesQueryKey
>;

export function getApiV1ClassroomdisciplineSharedDisciplinesQueryOptions(
  params?: GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ClassroomdisciplineSharedDisciplinesQueryKey(params);
  return queryOptions<
    GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedDisciplines401>,
    GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ClassroomdisciplineSharedDisciplines(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description  **(Requer Authorization para autenticação)**
 * @summary Lookup de disciplinas ativas (nome resolvido por cultura) (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/shared/disciplines}
 */
export function useGetApiV1ClassroomdisciplineSharedDisciplines<
  TData = GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
  TQueryData = GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1ClassroomdisciplineSharedDisciplinesQueryKey,
>(
  params?: GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
        ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedDisciplines401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ClassroomdisciplineSharedDisciplinesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ClassroomdisciplineSharedDisciplinesQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ClassroomdisciplineSharedDisciplines401>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
